import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { LoaderScreen } from "../../components/LoaderScreen";
import { FormatMoney } from "../../../Helpers/FormatNumber";
import {
  Autocomplete,
  Button,
  InputAdornment,
  Stack,
  TextField,
} from "@mui/material";
import AddBoxIcon from "@mui/icons-material/AddBox";
import RequestPageIcon from "@mui/icons-material/RequestPage";
import ArticleIcon from "@mui/icons-material/Article";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import PercentIcon from "@mui/icons-material/Percent";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import request from "../../../Helpers/API";
import Swal from "sweetalert2";
import { GetKey } from "../../../Helpers/GetKey";

export const PagareSaveChanges = () => {
  const [cargado, setCargado] = useState(false);
  const location = useLocation();
  const history = useHistory();
  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });
  const [data, setData] = useState(location.state);
  const [arrayclientes, setArrayClientes] = useState([]);
  const [arrayVendedor, SetArrayVendedor] = useState([]);
  const [state, setState] = useState({
    documento: "",
    seriefiscal: "",
    foliofiscal: "",
    idcliente: "",
    idvendedor: "",
    suscripcion: "",
    tieneintereses: "",
    tasa: "",
    interesdiario: 0,
    interesapagar: 0,
    diasfinanciamiento: 0,
    montofinanciar: 0,
    montointereses: 0,
    financiera: "",
    vencimiento: "",
  });
  useEffect(() => {
    if (
      state.tieneintereses === undefined ||
      state.tieneintereses === "" ||
      state.tieneintereses === "NO"
    ) {
      setState({
        ...state,
        tasa: 0,
        interesapagar: 0,
        montointereses: 0,
      });
    }
  }, [state.tieneintereses]);

  useEffect(() => {
    if (state.tieneintereses === "SI") {
      var interesdiario =
        ((Number(state.tasa) / 100) * state.montointereses) / 360;
      setState({
        ...state,
        interesdiario,
        interesapagar: interesdiario * state.diasfinanciamiento,
      });
    }
  }, [state.tasa, state.montointereses]);
  const [ArrayFinanciera, setArrayFinanciera] = useState(["MHU", "JDF"]);
  const [opcionalArray, setOpcionalArray] = useState(["SI", "NO"]);

  useEffect(() => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(`FacturacionSinFolio/GETBYID?ID=${data.id}`)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setArrayClientes(result.clientes);
        SetArrayVendedor(result.vendedor);
        var factura = result.factura;
        setState({
          ...state,
          documento: factura.documento,
          seriefiscal: factura.serie,
          foliofiscal: factura.folio,
          idcliente: factura.cliente,
          suscripcion: factura.dtpfechasuscripcion,
          tieneintereses: factura.tieneinteres === true ? "SI" : "NO",
          tasa: factura.tasa,
          interesdiario: factura.interesdiario,
          interesapagar: factura.intereses,
          diasfinanciamiento: factura.diasfinanciamiento,
          montofinanciar: factura.montofinanciado,
          montointereses: factura.montointereses,
          idvendedor: factura.vendedor,
          vencimiento: factura.dtpvencimiento,
          financiera: factura.financiera,
        });
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire({
          icon: "error",
          title: "REGISTRO DE PAGARES",
          text: JSON.stringify(error),
        });
      });
  }, [data]);
  const onGuardar = () => {
    if (state.documento === "") {
      Swal.fire({
        icon: "error",
        title: "CREDITO POR OPERACION",
        text: "Favor de agregar el documento de origen",
      });
      return;
    }
    if (state.seriefiscal === "") {
      Swal.fire({
        icon: "error",
        title: "CREDITO POR OPERACION",
        text: "Favor de agregar la serie fiscal",
      });
      return;
    }
    if (state.foliofiscal === "") {
      Swal.fire({
        icon: "error",
        title: "CREDITO POR OPERACION",
        text: "Favor de agregar el folio fiscal",
      });
      return;
    }
    if (state.idcliente === "") {
      Swal.fire({
        icon: "error",
        title: "CREDITO POR OPERACION",
        text: "Favor de agregar el cliente",
      });
      return;
    }
    if (state.fechasuscripcion === "") {
      Swal.fire({
        icon: "error",
        title: "CREDITO POR OPERACION",
        text: "Favor de agregar la fecha de suscripción",
      });
      return;
    }
    if (state.tieneintereses === "") {
      Swal.fire({
        icon: "error",
        title: "CREDITO POR OPERACION",
        text: "Favor de indicar si el documento tiene intereses pactados",
      });
      return;
    } else if (state.tieneintereses === "SI") {
      if (
        state.tasa === "" ||
        Number.isNaN(state.tasa) ||
        Number(state.tasa) === "0"
      ) {
        Swal.fire({
          icon: "error",
          title: "CREDITO POR OPERACION",
          text: "Favor de indicar la tasa del interes pactado",
        });
        return;
      }
    }
    setLoader({ ...loader, mostrar: true });
    const post = {
      idfactura: Number(data.id),
      serie: state.seriefiscal,
      folio: state.foliofiscal,
      documento: state.documento,
      cliente: GetKey(state.idcliente),
      vendedor: GetKey(state.idvendedor),
      fechasuscripcion: state.suscripcion,
      tieneinteres: state.tieneintereses === "SI" ? true : false,
      // tasa: state.tieneintereses === "SI" ? Number(state.tasa) : 0,
      tasa: Number(state.tasa),
      intereses:
        state.tieneintereses === "SI" ? Number(state.interesapagar) : 0,
      montofinanciado: Number(state.montofinanciar),
      montointereses: Number(state.montointereses),
      vencimiento: state.vencimiento,
      financiera: state.financiera,
    };
    request
      .post("FacturacionSinFolio/Guardar", post)
      .then(async() => {
        setLoader({ ...loader, mostrar: false });

        await Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Datos cargados con éxito",
          showConfirmButton: false,
          timer: 1000,
        });
        history.push("/Credito/listadopagares");
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire({
          icon: "error",
          title: "Clientes",
          text: JSON.stringify(error),
        });
      });
  };

  useEffect(() => {
    if (cargado === true) {
      setLoader({ ...loader, mostrar: true });
      //   var fecha1 = moment(state.suscripcion);
      //   var fecha2 = moment(data.vencimiento);
      request
        .get(
          `FacturacionSinFolio/DiasFinanciamiento?suscripcion=${state.suscripcion}&vencimiento=${state.vencimiento}`
        )
        .then((result) => {
          setLoader({ ...loader, mostrar: false });
          var interesdiario = 0;
          if (state.tieneintereses === "SI") {
            interesdiario = ((Number(state.tasa) / 100) * data.importe) / 360;
          }
          setState({
            ...state,
            interesdiario,
            interesapagar: interesdiario * result,
            diasfinanciamiento: result,
          });
        })
        .catch(() => {
          setState({
            ...state,
            diasfinanciamiento: 0,
          });
          setLoader({ ...loader, mostrar: false });
        });
    } else {
      setCargado(true);
    }
  }, [state.suscripcion]);

  return (
    <PlantillaScreen
      titulo={`${data.razonsocial}`}
      className={"pagares-savechanges"}
      className_main={1}
    >
      <LoaderScreen loader={loader} />
      <div className="pagares-savechanges-container">
        <div className="datos-pagare">
          <div className="datos-pagare-col2">
            <div className="data-col2">
              <div className="span1">Region:</div>
              <div className="value1"> {data.adr}</div>
            </div>
            <div className="data-col2">
              <div className="span">Fecha:</div>
              <div className="value2 ta-right"> {data.fecha}</div>
            </div>
          </div>

          <div className="datos-pagare-col2">
            <div className="data-col2">
              <div className="span1">Sucursal:</div>
              <div className="value1"> {data.sucursal}</div>
            </div>
            <div className="data-col2">
              <div className="span">Vencimiento:</div>
              <div className="value2 ta-right"> {data.vencimiento}</div>
            </div>
          </div>

          <div className="datos-pagare-col2">
            <div className="data-col2">
              <div className="span1">Modulo:</div>
              <div className="value1"> {data.modulo}</div>
            </div>
            <div className="data-col2">
              <div className="span">Importe:</div>
              <div className="value2 ta-right">
                {" "}
                {FormatMoney(data.importe)}
              </div>
            </div>
          </div>
        </div>
        <div className="formulario-facturas-sin-folio">
          <div className="openModal">
            <Autocomplete
              size="small"
              disablePortal
              id="idlcienteorigen"
              value={state.idcliente}
              className="icono-textbox Autocomplete-fs-12 "
              onChange={(event) =>
                setState({ ...state, idcliente: event.target.outerText })
              }
              options={arrayclientes.map(
                (item) => `${item.idcliente} - ${item.razonsocial}`
              )}
              sx={{ flex: 1 }}
              renderInput={(params) => (
                <TextField {...params} label="Cliente" />
              )}
              color="success"
            />
          </div>
          <div className="openModal mt-10">
            <Autocomplete
              size="small"
              fullWidth
              disablePortal
              id="idlcienteorigen"
              value={state.idvendedor}
              className="icono-textbox"
              onChange={(event) =>
                setState({ ...state, idvendedor: event.target.outerText })
              }
              options={arrayVendedor.map(
                (item) => `${item.idvendedor} - ${item.nombre}`
              )}
              sx={{ mt: 2 }}
              renderInput={(params) => (
                <TextField {...params} label="Vendedor" />
              )}
              color="success"
            />
            {/* <AddBoxIcon /> */}
          </div>
          <div className="openModal mt-10">
            <Autocomplete
              size="small"
              fullWidth
              disablePortal
              id="idlfinanciera"
              value={state.financiera}
              className="icono-textbox"
              onChange={(event) =>
                setState({ ...state, financiera: event.target.outerText })
              }
              options={ArrayFinanciera.map((item) => `${item}`)}
              sx={{ mt: 2 }}
              renderInput={(params) => (
                <TextField {...params} label="Financiera" />
              )}
              color="success"
            />
            {/* <AddBoxIcon /> */}
          </div>
          <Stack flexDirection={"row"} sx={{ mt: 2 }}>
            <TextField
              size="small"
              fullWidth
              className="icono-textbox"
              value={state.documento}
              onChange={({ target }) =>
                setState({ ...state, documento: target.value })
              }
              label="Documento"
              color="success"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <ArticleIcon />
                  </InputAdornment>
                ),
              }}
            />
            <TextField
              size="small"
              fullWidth
              className="icono-textbox"
              sx={{
                ml: 1,
              }}
              value={state.seriefiscal}
              onChange={({ target }) =>
                setState({ ...state, seriefiscal: target.value })
              }
              label="Serie Fiscal"
              color="success"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <ArticleIcon />
                  </InputAdornment>
                ),
              }}
            />
            <TextField
              size="small"
              fullWidth
              className="icono-textbox"
              sx={{
                ml: 1,
              }}
              value={state.foliofiscal}
              onChange={({ target }) =>
                setState({ ...state, foliofiscal: target.value })
              }
              label="Folio Fiscal"
              color="success"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <ArticleIcon />
                  </InputAdornment>
                ),
              }}
            />
          </Stack>
          <Stack flexDirection={"row"} sx={{ mt: 1 }}>
            <TextField
              size="small"
              fullWidth
              className="icono-textbox"
              sx={{
                mt: 1,
              }}
              value={state.vencimiento}
              onChange={({ target }) =>
                setState({ ...state, vencimiento: target.value })
              }
              type="date"
              label="Fecha Vencimiento"
              color="success"
              
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <ArticleIcon />
                  </InputAdornment>
                ),
              }}
            />
            <TextField
              size="small"
              fullWidth
              className="icono-textbox"
              sx={{
                mt: 1,
                ml: 1,
              }}
              value={state.montofinanciar}
              onChange={({ target }) =>
                setState({ ...state, montofinanciar: target.value })
              }
              type="number"
              label="Monto Financiado"
              color="success"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <ArticleIcon />
                  </InputAdornment>
                ),
              }}
            />
          </Stack>
          <Stack flexDirection={"row"} sx={{ mt: 2 }}>
            <TextField
              size="small"
              className="icono-textbox"
              value={state.suscripcion}
              onChange={({ target }) =>
                setState({ ...state, suscripcion: target.value })
              }
              sx={{ width: "50%", mr: 1 }}
              type="date"
              label="Fecha de suscripción"
              color="success"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <CalendarMonthIcon />
                  </InputAdornment>
                ),
              }}
            />
            <TextField
              size="small"
              className="icono-textbox"
              value={state.tasa}
              onChange={({ target }) =>
                setState({ ...state, tasa: target.value })
              }
              sx={{ width: "50%" }}
              fullWidth
              type="number"
              label="Tasa del interes pactado"
              color="success"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <PercentIcon />
                  </InputAdornment>
                ),
              }}
            />
          </Stack>
          <Autocomplete
            size="small"
            fullWidth
            sx={{ mt: 2 }}
            disablePortal
            id="tieneintereses"
            value={state.tieneintereses}
            className="icono-textbox"
            onChange={(event) =>
              setState({ ...state, tieneintereses: event.target.outerText })
            }
            options={opcionalArray.map((item) => `${item}`)}
            renderInput={(params) => (
              <TextField {...params} label="Tiene Intereses" />
            )}
            color="success"
          />
          {state.tieneintereses === "SI" ? (
            <>
              <TextField
                size="small"
                fullWidth
                className="icono-textbox"
                sx={{
                  mt: 2,
                }}
                value={state.montointereses}
                onChange={({ target }) =>
                  setState({ ...state, montointereses: target.value })
                }
                type="number"
                label="Monto Calcula Intereses"
                color="success"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <ArticleIcon />
                    </InputAdornment>
                  ),
                }}
              />
              <Stack flexDirection={"row"} sx={{ mt: 2 }}>
                <TextField
                  disabled
                  size="small"
                  className="icono-textbox"
                  value={state.diasfinanciamiento}
                  sx={{ width: "50%" }}
                  type="number"
                  label="Dias Fin."
                  color="success"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <RequestPageIcon />
                      </InputAdornment>
                    ),
                  }}
                />
                <TextField
                  disabled
                  size="small"
                  className="icono-textbox"
                  sx={{ ml: 1, width: "50%" }}
                  value={FormatMoney(state.interesdiario)}
                  label="Interes Diario"
                  color="success"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <RequestPageIcon />
                      </InputAdornment>
                    ),
                  }}
                />
                <TextField
                  disabled
                  size="small"
                  className="icono-textbox"
                  sx={{ ml: 1, width: "50%" }}
                  value={FormatMoney(state.interesapagar)}
                  label="Interes Pactado"
                  color="success"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <RequestPageIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </Stack>
            </>
          ) : (
            <></>
          )}
        </div>
        <div className="pagare-savechanges-footer">
          <Button
            onClick={() =>
              history.push("/Credito/listadopagares")
            }
            color="error"
            variant="contained"
            size="small"
            sx={{
              mr: 1,
            }}
          >
            Regresar
          </Button>
          <Button
            onClick={() => onGuardar()}
            color="success"
            variant="contained"
            size="small"
          >
            Guardar
          </Button>
        </div>
      </div>
    </PlantillaScreen>
  );
};
